module.exports = __webpack_public_path__ + "static/media/card-MasterCard.47cd1ad6.svg";